// Sawyer 09 pet-inactivity (D1)
/** `2099-06-09` → `Jun 9, 2099`, as a CALENDAR date (no timezone shift; the #1156 lesson). */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function calendarDateLabel(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return null;
  return `${MONTHS[Number(m[2]) - 1] ?? m[2]} ${Number(m[3])}, ${m[1]}`;
}

export function inactiveSinceLabel(iso: string | null | undefined): string | null {
  const d = calendarDateLabel(iso);
  return d ? `Inactive since ${d}` : null;
}
